import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image, Text } from '@fluentui/react-components';

import classNames from 'classnames';
import {
  Collapse,
  useCollapseState,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { LinkedInLogo24 } from '@bingads-webui-campaign-react/linkedin-shared-components';

import { FormCard, FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';

import { getCompanyPageStyle } from '../styles/company-page-style';
import DEFAULT_PROFILE_IMAGE from '../media/default-profile-image.svg';

export const CompanyPageCard = ({ companyInfo }) => {
  const {
    LogoDownloadUrl: userProfileImageSrc,
    Name: companyPageName,
    IndustryType: industryType,
    Location: industryLocation,
  } = companyInfo || {};

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getCompanyPageStyle);

  const [
    companyPageSection,
    companyPageExpandedSection,
    setcompanyPageExpandedSection,
  ] = useCollapseState(['company-page'], ['company-page']);

  const descriptionText = i18n.getString(_TL_('You have chosen to advertise with this company. Since you connected your Microsoft Advertising account to this company’s LinkedIn page, you won’t be able to connect your account to a different company. If at some point you want to serve ads for a different company, you’ll need to create a new Microsoft Advertising account.'));

  const industryText = [industryType, industryLocation].filter(Boolean).join(' . ');

  return (
    <div className="company-page-card">
      <Collapse
        allPanelItems={companyPageSection}
        checkItems
        skipItemsTypeCheck
        activeKeys={companyPageExpandedSection}
        setActiveKeys={setcompanyPageExpandedSection}
      >
        <FormCard
          className="company-page-card"
          key="company-page"
        >
          <FormCardBasicHeader
            title={i18n.getString(_TL_('Company'))}
            contentBefore={<LinkedInLogo24 />}
          />
          <FormCardBody>
            {/* TODO: add Learn more link */}
            <p className="company-page-description">{descriptionText}</p>
            <div className={classNames('company-page-info', classes.companyPageInfo)}>
              <div className={classes.imageContainer}>
                <Image
                  src={userProfileImageSrc || DEFAULT_PROFILE_IMAGE}
                  alt={i18n.getString(_TL_('User profile image'))}
                  className={classes.profileImage}
                />
              </div>
              <div className={classes.frame}>
                <Text className="company-page-info-title">{companyPageName}</Text>
                <Text className="company-page-info-text">{industryText}</Text>
              </div>
            </div>
          </FormCardBody>

        </FormCard>
      </Collapse>
    </div>
  );
};

CompanyPageCard.propTypes = {
  companyInfo: PropTypes.shape({
    userProfileImageSrc: PropTypes.string,
    companyPageName: PropTypes.string,
    industryType: PropTypes.string,
    industryLocation: PropTypes.string,
  }),
};

CompanyPageCard.defaultProps = {
  companyInfo: {
    userProfileImageSrc: '',
    companyPageName: '',
    industryType: '',
    industryLocation: '',
  },
};
